(function () {
    'use strict';
    var controllerId = 'cndRegister2B';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '_', fn_cndRegister2B]);

    function fn_cndRegister2B($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'Misura 2B - Registazione';
        vm.view = 'detail';       //Mettendo 'detail' si elimina l'errore del $compile: ctreq
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "register"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.isVisibleLinkDomanda = false;
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.confirm = {};
        vm.maxStep = 1;
        vm.actualAdesione = 0;
        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.PdfReady = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.myPristine = false;
        vm.isClickDay = false;
        vm.nrMesiTrc = 0;
        vm.errorAccess = '';
        vm.showToggle = false;
        vm.disableConfirm = false;


        //Pannelli dei dati (viewAccred)
        vm.showPanelAccred1 = true;
        vm.showPanelAccred2 = true;
        vm.setShowPanelAccred1 = setShowPanelAccred1;
        vm.setShowPanelAccred2 = setShowPanelAccred2;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.saving = false;

        vm.cndProgetto = {};
        vm.adesione = {};
        vm.urlRoot = datacontext.accreditamento_getURL();

        vm.testing = true;


        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Ragione Sociale', 'Codice Fiscale', 'Cod Ateco', 'Forma Giuridica'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };


        //Elenchi per filtri e finestra modale di Create

        vm.cmblist = {};

        // #region Localizzazione - Array

        vm.cmblist.paesi = [];
        vm.cmblist.province = [];
        vm.cmblist.comuni = [];
        vm.cmblist.tIndirizzi = [];

        vm.cmblist.paesi_nasc = [];
        vm.cmblist.province_nasc = [];
        vm.cmblist.comuni_nasc = [];

        vm.cmblist.paesi_lRes = [];
        vm.cmblist.province_lRes = [];
        vm.cmblist.comuni_lRes = [];
        vm.cmblist.tIndirizzi_lRes = [];

        vm.cmblist.paesi_lDom = [];
        vm.cmblist.province_lDom = [];
        vm.cmblist.comuni_lDom = [];
        vm.cmblist.tIndirizzi_lDom = [];

        vm.cmblist.paesi_sedeLeg = [];
        vm.cmblist.province_sedeLeg = [];
        vm.cmblist.comuni_sedeLeg = [];
        vm.cmblist.tIndirizzi_sedeLeg = [];

        vm.cmblist.paesi_sedeOper = [];
        vm.cmblist.province_sedeOper = [];
        vm.cmblist.comuni_sedeOper = [];
        vm.cmblist.tIndirizzi_sedeOper = [];

        // #endregion

        // #region Localizzazione Methods

        //(PaeseId, ComuneId)
        vm.change_Paesi = function () {
            if (vm.record.PaeseId > 0) {
                vm.record.ComuneId = 0;
                vm.record.ProvinciaId = 0;
            }
        };
        vm.change_Comuni = function (idProv) {
            vm.record.ComuneId = '';
            vm.getComuni(idProv);
        };
        vm.getComuni = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni = [];
            if (vm.record.ProvinciaId != idprov) vm.cmblist.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni = data;
            });
        };
        vm.getPaesi = function () {
            if (vm.cmblist.paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi = data;
            });
        };
        vm.getProvince = function () {
            if (vm.cmblist.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province = data;
            });
        };
        vm.getTIndirizzi = function () {
            if (vm.cmblist.tIndirizzi.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi = data;
            });
        };

        //(L_NascPaeseId, L_NascComuneId)
        vm.change_Paesi_Nasc = function () {
            if (vm.record.L_NascPaeseId > 0) {
                vm.record.L_NascComuneId = 0;
                vm.record.L_NascProvinciaId = 0;
            }
        };
        vm.change_Comuni_Nasc = function (idProv) {
            vm.record.L_NascComuneId = '';
            vm.getComuni_Nasc(idProv);
        };
        vm.getComuni_Nasc = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_nasc = [];
            if (vm.record.L_NascProvinciaId != idprov) vm.cmblist.comuni_nasc = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_nasc = data;
            });
        };
        vm.getPaesi_Nasc = function () {
            if (vm.cmblist.paesi_nasc.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_nasc = data;
            });
        };
        vm.getProvince_Nasc = function () {
            if (vm.cmblist.province_nasc.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_nasc = data;
            });
        };

        //(L_ResPaeseId, L_ResComuneId)
        vm.change_Paesi_LRes = function () {
            if (vm.record.L_ResPaeseId > 0) {
                vm.record.L_ResComuneId = 0;
                vm.record.L_ResProvinciaId = 0;
            }
        };
        vm.change_Comuni_LRes = function (idProv) {
            vm.record.L_ResComuneId = '';
            vm.getComuni_LRes(idProv);
        };
        vm.getComuni_LRes = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_lRes = [];
            if (vm.record.L_ResProvinciaId != idprov) vm.cmblist.comuni_lRes = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_lRes = data;
            });
        };
        vm.getPaesi_LRes = function () {
            if (vm.cmblist.paesi_lRes.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_lRes = data;
            });
        };
        vm.getProvince_LRes = function () {
            if (vm.cmblist.province_lRes.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_lRes = data;
            });
        };
        vm.getTIndirizzi_LRes = function () {
            if (vm.cmblist.tIndirizzi_lRes.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_lRes = data;
            });
        };

        //(L_DomPaeseId, L_DomComuneId)
        vm.change_Paesi_LDom = function () {
            if (vm.record.L_DomPaeseId > 0) {
                vm.record.L_DomComuneId = 0;
                vm.record.L_DomProvinciaId = 0;
            }
        };
        vm.change_Comuni_LDom = function (idProv) {
            vm.record.L_DomComuneId = '';
            vm.getComuni_LDom(idProv);
        };
        vm.getComuni_LDom = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_lDom = [];
            if (vm.record.L_DomProvinciaId != idprov) vm.cmblist.comuni_lDom = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_lDom = data;
            });
        };
        vm.getPaesi_LDom = function () {
            if (vm.cmblist.paesi_lDom.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_lDom = data;
            });
        };
        vm.getProvince_LDom = function () {
            if (vm.cmblist.province_lDom.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_lDom = data;
            });
        };
        vm.getTIndirizzi_LDom = function () {
            if (vm.cmblist.tIndirizzi_lDom.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_lDom = data;
            });
        };

        //(SedeLegale_PaeseId, SedeLegale_ComuneId)
        vm.change_Paesi_SedeLeg = function () {
            if (vm.record.SedeLegale_PaeseId > 0) {
                vm.record.SedeLegale_ComuneId = 0;
                vm.record.SedeLegale_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_SedeLeg = function (idProv) {
            vm.record.SedeLegale_ComuneId = '';
            vm.getComuni_SedeLeg(idProv);
        };
        vm.getComuni_SedeLeg = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeLeg = [];
            if (vm.record.SedeLegale_ProvinciaId != idprov) vm.cmblist.comuni_sedeLeg = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeLeg = data;
            });
        };
        vm.getPaesi_SedeLeg = function () {
            if (vm.cmblist.paesi_sedeLeg.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeLeg = data;
            });
        };
        vm.getProvince_SedeLeg = function () {
            if (vm.cmblist.province_sedeLeg.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_sedeLeg = data;
            });
        };
        vm.getTIndirizzi_SedeLeg = function () {
            if (vm.cmblist.tIndirizzi_sedeLeg.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeLeg = data;
            });
        };

        //(SedeOperativa_PaeseId, SedeOperativa_ComuneId)
        vm.change_Paesi_SedeOper = function () {
            if (vm.record.SedeOperativae_PaeseId > 0) {
                vm.record.SedeOperativa_ComuneId = 0;
                vm.record.SedeOperativa_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_SedeOper = function (idProv) {
            vm.record.SedeOperativa_ComuneId = '';
            vm.getComuni_SedeLeg(idProv);
        };
        vm.getComuni_SedeOper = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeOper = [];
            if (vm.record.SedeOperativa_ProvinciaId != idprov) vm.cmblist.comuni_sedeOper = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeOper = data;
            });
        };
        vm.getPaesi_SedeOper = function () {
            if (vm.cmblist.paesi_sedeOper.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeOper = data;
            });
        };
        vm.getProvince_SedeOper = function () {
            if (vm.cmblist.province_sedeOper.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_sedeOper = data;
            });
        };
        vm.getTIndirizzi_SedeOper = function () {
            if (vm.cmblist.tIndirizzi_sedeOper.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeOper = data;
            });
        };

        // #endregion


        vm.cmblist.tAssociazioni = [];
        vm.cmblist.tOrganismi = [];
        vm.cmblist.tAteco = [];


        //Metodi su interfaccia
        vm.activated = false;

        //Gestione conferma input di tipo Email
        vm.save = save;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;

        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;
        vm.setStep = setStep;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.SGO_DDG_Dt = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        loadStepParams();
        activate();

        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {

                    vm.record.Id = 0;
                    vm.record.TMisuraCode = '2B';
                    vm.record.TRuoloCode = 'AZD_PROM-2B';
                    vm.record.L_NascPaeseId = 0;
                    vm.record.L_ResPaeseId = 0;
                    vm.record.L_DomPaeseId = 0;
                    vm.record.SedeLegale_PaeseId = 0;
                    vm.record.SedeOperativa_PaeseId = 0;
                    vm.confirm.SedeLegale_Email = '';
                    vm.confirm.SedeLegale_PEC = '';
                    vm.record.SedeLegale_TIndirizzoId = 1;
                    vm.record.L_ResTIndirizzoId = 1;

                    //Necessario per specializzare il modulo Register
                    vm.record.misura = '2B';

                    var isDebug = false;
                    if (isDebug) {
                        vm.record.L_Cognome = 'Rossi';
                        vm.record.L_Nome = 'Mario';
                        vm.record.L_CodiceFiscale = 'RSSMRA80A01I754N';
                        vm.record.L_Sesso = 'M';
                        vm.record.L_NascProvinciaId = 89;
                        vm.getComuni_Nasc(vm.record.L_NascProvinciaId);
                        vm.record.L_NascComuneId = 6886;
                        vm.record.L_DtNasc = '01/01/1980';

                        vm.record.DDG_Num = '123-R1';
                        vm.record.DDG_Dt = '21/06/2015';

                        vm.record.Dlgs196 = true;

                        vm.record.L_ResProvinciaId = 89;
                        vm.getComuni_LRes(vm.record.L_ResProvinciaId);
                        vm.record.L_ResComuneId = 6886;
                        vm.record.L_ResTIndirizzoId = 1;
                        vm.record.L_ResIndirizzo = 'LIBERTA';
                        vm.record.L_ResCivico = '1A';
                        vm.record.L_ResCap = '96010';
                        vm.record.L_Ruolo = 'Amministratore';
                        vm.record.L_Cellulare = '33333333';
                        vm.record.L_Email = 'm.rossi80@dominio.it';

                        vm.record.SedeLegale_ProvinciaId = 89;
                        vm.getComuni_SedeLeg(vm.record.SedeLegale_ProvinciaId);
                        vm.record.SedeLegale_ComuneId = 6886;
                        vm.record.SedeLegale_TIndirizzoId = 1;
                        vm.record.SedeLegale_Indirizzo = 'LIBERTA';
                        vm.record.SedeLegale_Civico = '1A';
                        vm.record.SedeLegale_Cap = '96010';

                        vm.record.SedeLegale_Telefono = '999999';
                        vm.record.SedeLegale_Cellulare = '99999999';
                        vm.record.SedeLegale_Email = 'marco_calogero@yahoo.it';
                        vm.confirm.SedeLegale_Email = 'marco_calogero@yahoo.it';
                        vm.record.SedeLegale_PEC = 'm.rossi80@dominio.it';
                        vm.confirm.SedeLegale_PEC = 'm.rossi80@dominio.it';                        

                        vm.record.RagioneSociale = 'LIBERTA';
                        vm.record.PIVA = '01234567897';
                        vm.record.CodiceFiscale = '01234567899';
                        vm.record.TAtecoId = 988;
                        vm.record.searchTextAteco = '[63] ATTIVIT\xC0 DEI SERVIZI D\'INFORMAZIONE E ALTRI SERVIZI INFORMATICI';
                    }

                    var promises = [
                        getTAteco()
                        //Localizzazioni
                        , vm.getPaesi()
                        , vm.getProvince()
                        , vm.getTIndirizzi()
                        , vm.getPaesi_Nasc()
                        , vm.getProvince_Nasc()
                        , vm.getPaesi_LRes()
                        , vm.getProvince_LRes()
                        , vm.getTIndirizzi_LRes()
                        , vm.getPaesi_LDom()
                        , vm.getProvince_LDom()
                        , vm.getTIndirizzi_LDom()
                        , vm.getPaesi_SedeLeg()
                        , vm.getProvince_SedeLeg()
                        , vm.getTIndirizzi_SedeLeg()
                        , vm.getPaesi_SedeOper()
                        , vm.getProvince_SedeOper()
                        , vm.getTIndirizzi_SedeOper()
                    ];
                    return common.activateController(promises, controllerId)
                        .then(function () {
                            return setStep(0);
                        });
                });
            }
        }


        //****************************************************
        // METODI GESTIONE VIEW
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function nextStep() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    setStep(vm.actualStep + 1);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "F1";
            vm.titlesStep[0] = "1\u00BA Fase";
            vm.subtitlesStep[0] = "Registrazione";
            vm.descriptionsStep[0] = "Compilare il modulo e premere il pulsante 'Registra'.<br />Il sistema invier\xE0 le credenziali di accesso alla piattaforma (username e password) all'indirizzo email inserito.";

            //vm.labelsStep[1] = "B";
            //vm.titlesStep[1] = "Fase B";
            //vm.subtitlesStep[1] = "Dichiarazione tirocinante";
            //vm.descriptionsStep[1] = "In questa fase &egrave; richiesto l'inserimento dei dati necessari alla compilazione del 'Modulo di adesione del tirocinante' (Allegato B) e, se del caso, della 'Scheda del Progetto Formativo' (Allegato C).<br/>Per aggiungere l'eventuale secondo tirocinante utilizzare il pulsante 'Aggiungi Tirocinante'; per navigare tra i tirocinanti utilizzare il pulsante 'Scheda tirocinante'.";

            //vm.labelsStep[2] = "C";
            //vm.titlesStep[2] = "Fase C";
            //vm.subtitlesStep[2] = "Upload Documentale";
            //vm.descriptionsStep[2] = "In questa fase occore scaricare gli allegati A, B, C (nel caso ci sia) generati dal portale, firmarli (l'allegato A va firmato digitalmente) e ricaricarli unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            //vm.labelsStep[3] = "D";
            //vm.titlesStep[3] = "Fase D";
            //vm.subtitlesStep[3] = "Stampa ricevuta";
            //vm.descriptionsStep[3] = "In questa fase &egrave possibile stampare la 'Ricevuta di adesione' che contiene il numero di istanza da riportare nell'oggetto della PEC e da allegare nella stessa.";
        }

        function setStepDefault() {
            setStep(0);
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            vm.subStep = "";
            switch (vm.actualStep) {
                case 0:
                    setView('viewAccred');
                    vm.actualAdesione = 0;
                    break;
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            //var spanEdit = 'span-select';
            //var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[1] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[2] = vm.record != undefined && vm.record.attachChecked;
            vm.stepCompleted[3] = vm.record != undefined && vm.record.Sent;

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAccred':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewAdes':
                    if (vm.record.Adesioni != undefined && vm.record.Adesioni[0] != undefined && vm.record.Adesioni[0].Id > 0)
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < vm.maxStep - 1 && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid || vm.saving;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.disableConfirm
                        || vm.record.SedeLegale_PEC != undefined && vm.record.SedeLegale_PEC.toLowerCase() != vm.confirm.SedeLegale_PEC.toLowerCase()
                        || vm.record.SedeLegale_Email != undefined && vm.record.SedeLegale_Email.toLowerCase() != vm.confirm.SedeLegale_Email.toLowerCase();
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }

        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }

        //Gestione per viewAccred
        function setShowPanelAccred1() {
            return vm.showPanelAccred1 = !vm.showPanelAccred1;
        }
        function setShowPanelAccred2() {
            return vm.showPanelAccred2 = !vm.showPanelAccred2;
        }

        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;
                        //console.info('getCNDProgetto', data);
                        var dt = new Date(vm.cndProgetto.DttmServer);
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");


                        vm.dtStartClickDay = new Date(vm.cndProgetto.DtStartClickDay);
                        vm.dtEndClickDay = new Date(vm.cndProgetto.DtEndClickDay);

                        vm.isClickDay = vm.cndProgetto.IsClickDay;

                        vm.endTime = vm.dtStartClickDay;
                        vm.countdown = (vm.dtStartClickDay - dt) / 1000;

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }


                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkVideoGuida(vm.cndProgetto.URL_YouTube);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');
                        sectionMenu.setProjectUID(vm.cndProgetto.UID);

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        function save() {
            //console.info('save()', vm.record);
            if (typeof vm.record.TAtecoId == 'undefined' || vm.record.TAtecoId == null || vm.record.TAtecoId == 0 || vm.record.TAtecoId == '') {
                return logError('Il campo codice ateco deve essere compilato');
            }
            
            if (typeof vm.record.Id == 'undefined' || vm.record.Id == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta effettuando la registrazione, i dati inseriti non potranno essere modificati, procedere?', 'OK').then(
                    function () { //YES
                        vm.loading = true;
                        vm.saving = true;
                        return datacontext.cndRegister_save(vm.record).then(function (data) {
                            vm.loading = false;
                            vm.saving = false;
                            if (data == "400") {
                                return logError('Errore: campi non correttamente valorizzati. ');
                            }
                            else if (data == "404") {
                                return logError('Errore: non specifico. Dato non registrato. ');
                            }
                            else if (data == "403") {
                                return logError('Errore: il campo "CIR" gi\xE0 esistente. ');
                            }
                            else if (data == "409") {
                                return logError('Errore: il campo "Email" oppure il campo "Username" \xE8 gi\xE0 stato utilizzato da una utenza precedentemente. ');
                            }
                            else if (data == "406") {
                                return logError('Errore: partita IVA gi\xE0 esistente. ');
                            }
                            else if (data == "201") {
                                vm.disableConfirm = true;
                                return setView('viewConfirm');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        vm.saving = false;
                    }
                );
            }
        }


        // ******************************
        // showAlert
        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }
        //*****************************************************
        //Elenchi Parametri

        function getTAteco() {
            if (vm.cmblist.tAteco.length > 0) return;

            datacontext.arrTipoAteco().then(function (data) {
                vm.cmblist.tAteco = data;
            });
        }

        // #region FUNZIONI DI SUPPORTO

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- SUGGESTION PER CODICE ATECO -#-#-#-#-#-#
        //Define Suggestions List
        vm.suggestionsAteco = [];
        vm.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        vm.selectedIndexAteco = -1;
        //Function To Call On ng-change
        vm.searchAteco = function () {
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
            if (vm.record.searchTextAteco == undefined) return;
            if (vm.record.searchTextAteco.length < 5) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText(vm.record.searchTextAteco).then(function (data) {
                //console.log(data);
                if (data) {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        vm.suggestionsAteco.push(item.Name);
                    });
                }
                if (vm.suggestionsAteco.length == 1) {
                    vm.AssignValueAndHideAteco(0);
                }
            });
        };
        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            if (val !== -1 && typeof val != 'undefined') {
                vm.record.searchTextAteco = vm.suggestionsAteco[vm.selectedIndexAteco];
                vm.record.TAtecoId = vm.suggestionsObjAteco[vm.selectedIndexAteco].Id;
            }
        });
        //Reset Text of Ateco
        vm.resetTextAteco = function () {
            if (vm.record.TAtecoId > 0) {
                vm.record.TAtecoId = '';
                vm.validAteco = false;
                vm.record.searchTextAteco = '';
            }
        };
        //Text Field Events
        //Function To Call on ng-keydown
        vm.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco + 1 !== vm.suggestionsAteco.length) {
                    vm.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco - 1 !== -1) {
                    vm.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                vm.suggestionsAteco = [];
                vm.suggestionsObjAteco = [];
            }
        };
        //Function To Call on ng-keyup
        vm.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if (vm.record.searchTextAteco == "") {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = [];
                }
            } else {
                if (vm.record.TAtecoId > 0) {
                    vm.record.TAtecoId = '';
                    vm.record.searchTextAteco = '';
                }
            }
        };
        //======================================
        //List Item Events
        //Function To Call on ng-click
        vm.AssignValueAndHideAteco = function (index) {
            //console.log('hide');
            vm.record.searchTextAteco = vm.suggestionsAteco[index];
            vm.record.TAtecoId = vm.suggestionsObjAteco[index].Id;
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
        };
        //======================================
        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- END -#-#-#-#-#-#

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.checkPIVA = function (value) {
            vm.validPIVA = true;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            vm.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- EXISTS PARTITA IVA -#-#-#-#-#-#
        vm.exixstPIVA = false;
        vm.getByPIVA = function (value) {
            vm.exixstPIVA = false;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            vm.exixstPIVA = true;
            return datacontext.validazione_existAzienda(0, '', 'PROM', '2A', '', value).then(function (data) {
                return vm.exixstPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.checkCF = function (value) {
            vm.validCF = true;
            var isEnte = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            if (value.length == 11) isEnte = true;
            vm.validCF = false;
            return datacontext.validazione_cf(value, isEnte).then(function (data) {
                return vm.validCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- EXISTS CODICE FISCALE -#-#-#-#-#-#
        vm.exixstCF = false;
        vm.getByCF = function (value) {
            vm.exixstCF = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            vm.exixstCF = true;
            return datacontext.validazione_existAzienda(0, '', 'PROM', '2A', value, '').then(function (data) {
                return vm.exixstCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.checkFieldsCF = function () {
            vm.validFieldsCF = true;
            if (vm.record.L_CodiceFiscale == undefined) return;
            if (vm.record.L_CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if (vm.record.L_Nome == undefined) return;
            if (vm.record.L_Cognome == undefined) return;
            if (vm.record.L_Sesso == undefined) return;
            if (vm.record.L_NascPaeseId == 0 && (vm.record.L_NascComuneId == undefined || vm.record.L_NascComuneId == 0)) return;
            if (vm.record.L_DtNasc == undefined || vm.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString(vm.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy            
            vm.validFieldsCF = false;
            return datacontext.validazione_fieldsCF(vm.record.L_CodiceFiscale, vm.record.L_Nome, vm.record.L_Cognome, vm.record.L_Sesso, strDtNasc, vm.record.L_NascPaeseId, vm.record.L_NascComuneId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.checkIBAN = function () {
            vm.validIBAN = true;
            if (vm.record.IBAN == undefined) return;
            if (vm.record.IBAN.length != 27) return; //numero minimo di caratteri
            vm.validIBAN = false;
            return datacontext.validazione_iban(vm.record.IBAN).then(function (data) {
                return vm.validIBAN = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VERIFICA USERNAME -#-#-#-#-#-#
        vm.existsUsername = false;
        vm.checkUsername = function () {
            if (vm.record.Username == undefined || vm.record.Username.length < 5) {
                vm.existsUsername = false;
                return;
            }
            //vm.existsUsername = true;
            return datacontext.validazione_existUsername(vm.record.Username, '', 0).then(function (data) {
                return vm.existsUsername = data;
            });
        };

        // #endregion






    }
})();
